import Link from "next/link";
import { useState } from "react";
import { Ads, StickyAds } from "../../ads/Ads";
import { GlobalShare } from "../../SocialButtons";
import RaceWidget from "../../RaceWidget";
import ResultsNavBar from "../ResultsNavBar";
import Senatorial from "../../SenatorialWidget";
import PartyList from "../../partylist/PartyListWidget";
import MapResults from "./map/MapResults";
import styles from "../../../styles/races/national/NationalRace.module.scss";

const NationalRace = ({
  view,
  path,
  presidential,
  vPresidential,
  senatorialList,
  partyList,
  partyListMain,
  allPartyList,
  url,
  regionList,
  provincesList,
  cityList,
  philippines,
  locationViceData = [],
  locationPresData = [],
}) => {
  const [isMounted, setIsMounted] = useState(false);

  const ResultsViewHandler = ({ cssContainer, children }) => {
    switch (view) {
      case "map":
      case "overseas-absentee-voting-results":
      case "results":
      case "official-results":
      default:
        return <div className={cssContainer}>{children}</div>;
    }
  };

  const nationalRacesByPath = () => {
    switch (path) {
      case "president-vice-president":
        let twitterQuote = "";
        switch (view) {
          case "overseas-absentee-voting-results":
            twitterQuote =
              "#PHVoteResults: 2022 PH election overseas voting results for president and vp  #PHVote #WeDecide";
            break;
          case "results":
            twitterQuote =
              "#PHVoteResults: 2022 Philippine election results for president, vice president #PHVote #WeDecide";
            break;
          case "official-results":
            twitterQuote =
              "Official 2022 presidential and vice presidential election results #PHVote #WeDecide #PHVoteResults";
            break;
          default:
            twitterQuote =
              "Partial, official 2022 presidential and vice presidential election results #PHVote #WeDecide #PHVoteResults ";
            break;
        }
        if (view === "map-results") {
          return (
            <MapResults
              presidential={presidential}
              vPresidential={vPresidential}
              url={url}
              regionList={regionList}
              provincesList={provincesList}
              cityList={cityList}
              philippines={philippines}
              isEmbedShowed={true}
              locationViceData={locationViceData}
              locationPresData={locationPresData}
            />
          );
        } else {
          return (
            <ResultsViewHandler cssContainer={styles.presVpContainer}>
              <RaceWidget
                view={view}
                withCollapse={false}
                candidatesList={presidential?.results}
                regionList={regionList}
                contestName="presidential race"
                raceName="PRESIDENT PHILIPPINES"
                description="The winner will become the 17th president of the Philippines, to serve for six years starting noon of June 30, 2022. "
                readMoreLink="https://www.rappler.com/nation/elections/president-vp-philippines-powers-duties/"
                quote={twitterQuote}
                urlPath="/elections/2022/candidates/"
                url={url}
                marginTop="marginTop"
              />
              <Ads
                id={`national-${path}-middle1-mobile`}
                adType="middle1"
                deviceType="mobile"
                pageType="elec_national_candidate"
              />
              <RaceWidget
                view={view}
                withCollapse={false}
                candidatesList={vPresidential?.results}
                provincesList={provincesList}
                regionList={regionList}
                contestName="vice presidential race"
                raceName="VICE PRESIDENT PHILIPPINES"
                description="The winner will become the 15th vice president of the Philippines, to serve for six years, starting noon of June 30, 2022. "
                readMoreLink="https://www.rappler.com/nation/elections/president-vp-philippines-powers-duties/"
                quote={twitterQuote}
                urlPath="/elections/2022/candidates/"
                url={url}
                marginTop="marginTop"
              />
            </ResultsViewHandler>
          );
        }
      case "senator":
        return (
          <ResultsViewHandler cssContainer={styles.senPartyListContainer}>
            <Senatorial
              view={view}
              withCollapse={false}
              regionList={regionList}
              senatorialList={senatorialList}
              urlPath="/elections/2022/candidates/"
              url={url}
            />
          </ResultsViewHandler>
        );
      case "party-list":
        return (
          <ResultsViewHandler cssContainer={styles.senPartyListContainer}>
            <PartyList
              view={view}
              regionList={regionList}
              partyList={partyList}
              partyListMain={partyListMain}
              allPartyList={allPartyList}
              url={url}
            />
          </ResultsViewHandler>
        );
      default:
        break;
    }
  };

  return (
    <div className={styles.natRaceContainer}>
      <h2 className={styles.headerResults}> 2022 NATIONAL RESULTS</h2>
      <div className={styles.navContainer}>
        <Link
          href={
            view === "default"
              ? "/elections/2022/races/president-vice-president"
              : "/elections/2022/races/president-vice-president/results"
          }
          passHref
        >
          <a
            className={
              path === "president-vice-president" ? styles.highlight : ""
            }
          >
            PRESIDENT & VICE PRESIDENT
          </a>
        </Link>
        <Link
          href={
            view === "default"
              ? "/elections/2022/races/senator"
              : "/elections/2022/races/senator/results"
          }
          passHref
        >
          <a className={path === "senator" ? styles.highlight : ""}>SENATOR</a>
        </Link>
        <Link
          href={
            view === "default"
              ? "/elections/2022/races/party-list"
              : "/elections/2022/races/party-list/results"
          }
          passHref
        >
          <a className={path === "party-list" ? styles.highlight : ""}>
            PARTY LIST
          </a>
        </Link>

        <div className={styles.globalShare_desktop}>
          <GlobalShare
            title="Share this page"
            url={url}
            fbQuote="2022 Philippine Elections - Candidates for national and local races"
            tWQuoute="2022 Philippine Elections - Candidates for national and local races"
            toolTipId={"toolTip_Default"}
            isMounted={isMounted}
            containerStyle={styles.gs_desktop}
          />
        </div>
      </div>

      {view !== "default" && (
        <ResultsNavBar
          url={`${process.env.SITE_URL}elections/2022/races/`}
          path={path}
          view={view}
        />
      )}

      <div className={styles.globalShare_mobile}>
        <GlobalShare
          title="Share this page"
          url={url}
          fbQuote="2022 Philippine Elections - Candidates for national and local races"
          tWQuoute="2022 Philippine Elections - Candidates for national and local races"
          toolTipId={"toolTip_Default"}
          isMounted={isMounted}
          containerStyle={styles.gs_mobile}
        />
      </div>
      <Ads
        id={`national-${path}-billboard-desktop`}
        adType="billboard"
        deviceType="desktop"
        pageType="elec_national_candidate"
      />
      <Ads
        id={`national-${path}-billboard-mobile`}
        adType="billboard"
        deviceType="mobile"
        pageType="elec_national_candidate"
      />
      {nationalRacesByPath()}
      <Ads
        id={`national-${path}-leaderboard1-desktop`}
        adType="leaderboard1"
        deviceType="desktop"
        pageType="elec_national_candidate"
      />
      <Ads
        id={`national-${path}-middle2-mobile`}
        adType="middle2"
        deviceType="mobile"
        pageType="elec_national_candidate"
      />
      <StickyAds
        id={`national-${path}-sticky-desktop`}
        deviceType="desktop"
        pageType="elec_national_candidate"
      />
      <StickyAds
        id={`national-${path}-sticky-mobile`}
        deviceType="mobile"
        pageType="elec_national_candidate"
      />
    </div>
  );
};

export default NationalRace;
